var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotivationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.7812C13.8122 10.7812 15.2812 9.31218 15.2812 7.5C15.2812 5.68782 13.8122 4.21875 12 4.21875C10.1878 4.21875 8.71875 5.68782 8.71875 7.5C8.71875 9.31218 10.1878 10.7812 12 10.7812Z",
    fill: "#A66855"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.8125C12.3884 2.8125 12.7031 2.49769 12.7031 2.10938V0.703125C12.7031 0.314812 12.3883 0 12 0C11.6117 0 11.2969 0.314812 11.2969 0.703125V2.10938C11.2969 2.49769 11.6117 2.8125 12 2.8125Z",
    fill: "#A66855"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34419 3.27734C8.53835 3.61363 8.96838 3.72889 9.30466 3.53469C9.64094 3.34053 9.75616 2.9105 9.56201 2.57422L8.85888 1.35636C8.66473 1.02008 8.23469 0.904859 7.89841 1.09902C7.56213 1.29317 7.44691 1.7232 7.64107 2.05948L8.34419 3.27734Z",
    fill: "#A66855"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15327 5.06201L6.37113 5.76513C6.70741 5.95929 7.13744 5.84407 7.33159 5.50779C7.52575 5.17151 7.41053 4.74148 7.07425 4.54732L5.85639 3.84419C5.52011 3.65004 5.09008 3.76526 4.89592 4.10154C4.70172 4.43782 4.81694 4.86785 5.15327 5.06201Z",
    fill: "#A66855"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6684 5.50779C16.8626 5.84407 17.2926 5.95929 17.6289 5.76513L18.8467 5.06201C19.183 4.86785 19.2983 4.43782 19.1041 4.10154C18.9099 3.76526 18.4799 3.65004 18.1436 3.84419L16.9258 4.54732C16.5895 4.74148 16.4743 5.17151 16.6684 5.50779Z",
    fill: "#A66855"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6953 3.53469C15.0316 3.72884 15.4616 3.61363 15.6558 3.27734L16.3589 2.05948C16.553 1.7232 16.4378 1.29317 16.1015 1.09902C15.7653 0.904859 15.3352 1.02008 15.1411 1.35636L14.4379 2.57422C14.2438 2.9105 14.359 3.34053 14.6953 3.53469Z",
    fill: "#A66855"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54688 13.5938V19.7812H16.4531V13.5938C19.1714 13.5938 21.375 11.3902 21.375 8.67188V7.5C21.375 6.72333 20.7454 6.09375 19.9688 6.09375C19.1921 6.09375 18.5625 6.72333 18.5625 7.5V8.67188C18.5625 9.83686 17.6181 10.7812 16.4531 10.7812H15.344C14.4929 11.6485 13.3083 12.1875 12 12.1875C10.6917 12.1875 9.50714 11.6485 8.65598 10.7812H7.54688C6.38189 10.7812 5.4375 9.83686 5.4375 8.67188V7.5C5.4375 6.72333 4.80792 6.09375 4.03125 6.09375C3.25458 6.09375 2.625 6.72333 2.625 7.5V8.67188C2.625 11.3902 4.82859 13.5938 7.54688 13.5938Z",
    fill: "#A66855"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 21.1875H0.703125C0.314812 21.1875 0 21.5023 0 21.8906V23.2969C0 23.6852 0.314812 24 0.703125 24H23.2969C23.6852 24 24 23.6852 24 23.2969V21.8906C24 21.5023 23.6852 21.1875 23.2969 21.1875Z",
    fill: "#A66855"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotivationIcon);
export default __webpack_public_path__ + "static/media/motivationIcon.ea8dc153baeab3c1cf67d5c2fc2a6b92.svg";
export { ForwardRef as ReactComponent };